import { Factory } from 'rosie';

Factory.define('UserResetPassword').attr('name', 'USER_RESET_PASSWORD');

Factory.define('UserResetPasswordWithDefaults').extend('UserResetPassword');
